import dayjs from 'dayjs';
import { Calendar } from 'primereact/calendar';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors';
import { FormValues } from '../../CreateEditDialog.functions';

function WorkingHoursField() {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const working_hours_from = useWatch<FormValues, 'working_hours_from'>({
    name: 'working_hours_from',
  });

  const working_hours_to = useWatch<FormValues, 'working_hours_to'>({
    name: 'working_hours_to',
  });

  return (
    <div className="working-hours-wrapper">
      <FieldWithErrors name="working_hours_from" label={t('Working hours')}>
        <Controller
          name="working_hours_from"
          render={({ field }) => (
            <Calendar
              name="working_hours_from"
              inputId="working_hours_from"
              timeOnly
              stepMinute={5}
              value={field.value}
              onFocus={(e) => {
                console.log('working_hours_from ', e.target.value);
                if (
                  !working_hours_from ||
                  Object.keys(working_hours_from).length === 0
                ) {
                  setValue(
                    'working_hours_from',
                    dayjs().hour(8).minute(0).toDate()
                  );
                } else {
                  setValue('working_hours_from', working_hours_from);
                }
              }}
              inputClassName="data-cy-working_hours_from"
            />
          )}
        />
      </FieldWithErrors>

      <span className="divider">-</span>

      <FieldWithErrors name="working_hours_to" label=" ">
        <Controller
          name="working_hours_to"
          render={({ field }) => (
            <Calendar
              name="working_hours_to"
              inputId="working_hours_to"
              timeOnly
              stepMinute={5}
              value={field.value}
              onFocus={() => {
                if (
                  !working_hours_to ||
                  Object.keys(working_hours_to).length === 0
                ) {
                  setValue(
                    'working_hours_to',
                    dayjs().hour(16).minute(0).toDate()
                  );
                } else {
                  setValue('working_hours_to', working_hours_to);
                }
              }}
              inputClassName="data-cy-working_hours_to"
            />
          )}
        />
      </FieldWithErrors>
    </div>
  );
}

export default WorkingHoursField;
